<template>
  <div class="soar-container">
    <div class="flex flex-col gap-y-4">
      <h1 class="text-3xl">{{ $t('goldenResidencyServices') }}</h1>
      <div class="w-full flex items-center text-sm md:text-base">
        <!-- <TabberVue :items="tabItems" as="RouterLink">
          <template #default="{ item }">
            {{ $t(item.label) }}
          </template>
        </TabberVue> -->
        <router-link
          :class="[
            matchedRoute.includes('/services/golden-residency/about')
              ? 'text-primary border-b-2 border-primary'
              : 'border-b-2 border-transparent'
          ]"
          class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
          to="/services/golden-residency/about"
        >
          {{ $t('aboutGoldenResidency') }}
        </router-link>
        <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
        <router-link
          :class="[
            matchedRoute.includes('/services/golden-residency/services')
              ? 'text-primary border-b-2 border-primary'
              : 'border-b-2 border-transparent'
          ]"
          class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
          to="/services/golden-residency/services"
        >
          {{ $t('goldenServices') }}
        </router-link>
        <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
        <router-link
          :class="[
            matchedRoute.includes('/services/golden-residency/eligibility')
              ? 'text-primary border-b-2 border-primary'
              : 'border-b-2 border-transparent'
          ]"
          class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
          to="/services/golden-residency/eligibility"
        >
          {{ $t('checkEligibility') }}
        </router-link>
      </div>
    </div>

    <div class="pt-4">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import TabberVue from '@/components/Ui/Tabber.vue'

const route = useRoute()

const tabItems = [
  {
    label: 'aboutGoldenResidency',
    path: '/services/golden-residency/about'
  },
  {
    label: 'goldenServices',
    path: '/services/golden-residency/list'
  },
  {
    label: 'checkEligibility',
    path: '/services/golden-residency/eligibility'
  }
]

const matchedRoute = computed(() => {
  return route.matched.map((m) => m.path)
})
</script>

<script>
export default { name: 'GoldenRouter' }
</script>

<style lang="scss" scoped></style>
